import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../components/shared/Loader";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import { updateMeta } from "../../store/actions/metaAction";

const OpinionsCreate = () => {
	const auth = useSelector(state => state.auth.user);
	const history = useHistory();
	const [title, setTitle] = useState("");
	const [description, setDescription] = useState("");

	const [titleEn, setTitleEn] = useState("");
	const [descriptionEn, setDescriptionEn] = useState("");
	const [loading, setLoading] = useState(false);
	const [picture, setPicture] = useState(null);
	const [pictureMeta, setPictureMeta] = useState("");
	const [rating, setRating] = useState(5);

	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "اضافة رائ جديد",
				breadcrumb: "اراء العملاء",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
	};

	// const handlePicture = () => {
	// 	const fileInput = document.querySelector("#picture");
	// 	setPicture(URL.createObjectURL(fileInput.files[0]));
	// };
	const handlePicture = () => {
		setLoading(true);
		const fileInput = document.querySelector("#picture");
		setPicture(URL.createObjectURL(fileInput.files[0]));
		const data = new FormData();
		data.append("file", fileInput.files[0]);
		axios
			.post(`${process.env.REACT_APP_MAIN_URL}/api/admincp/upload`, data, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
					"Content-Type": "multipart/form-data",
				},
			})
			.then(response => {
				setPicture(response.data.data.name);
				setLoading(false);
				toast.success("تم رفع الصورة بنجاح!");
			})
			.catch(error => {
				toast.error("خطأ في رفع الصورة، برجاء المحاولة مرة أخرى!");
				setLoading(false);
			});
	};
	const deletePicture = () => {
		setPicture(null);
	};
	const handleSubmit = e => {
		e.preventDefault();

		if (!title || !titleEn || !description || !descriptionEn || !rating) {
			return toast.error("جميع البيانات مطلوبة");
		}

		const data = {
			title: {
				ar: title,
				en: titleEn,
			},
			description: {
				ar: description,
				en: descriptionEn,
			},
			image: picture,
			imageMeta: pictureMeta,
		     rating: rating
		};
		axios
			.post(
				`${process.env.REACT_APP_API_URL}/posts`,
				{
					admin_id: auth.id,
					category_id: 62,
					data: data,
				},
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(function (response) {
				history.push("/opinions/index");
				toast.success("تم اضافة البيانر بنجاح!");
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة مره اخرى!");
				setLoading(false);
			});
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div className="row">
					<div className="col-md-8">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="title">الاسم</label>
									<input
										type="text"
										id="title"
										onChange={e => setTitle(e.target.value)}
									/>
								</div>

								<div className="form-item">
									<label htmlFor="description">التعليق</label>
									<textarea
										id="description"
										cols="30"
										rows="2"
										onChange={e => setDescription(e.target.value)}
									/>
								</div>

								<div className="form-item">
									<label htmlFor="title"> الاسم بالانجليزيه </label>
									<input
										type="text"
										id="title"
										dir="ltr"
										onChange={e => setTitleEn(e.target.value)}
									/>
								</div>

								<div className="form-item">
									<label htmlFor="description"> التعليق بالانجليزيه</label>
									<textarea
										id="description"
										cols="30"
										rows="2"
										dir="ltr"
										onChange={e => setDescriptionEn(e.target.value)}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="rating"> ادخل التقيم(من 1 الي 5) </label>
									<input
										id="rating"
										type="number"
										onChange={e => setRating(Math.min(Math.max(parseInt(e.target.value , 10), 1), 5))}
										min="1"
										max="5"
										dir="ltr"
										value={rating}
										
									/>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-4">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="picture">الصوره</label>
									<div className="form-item ">
										<input
											type="text"
											id="pictureMeta"
											onChange={e => setPictureMeta(e.target.value)}
											value={pictureMeta}
											placeholder={"ادخل وصف الصوره"}
										/>
									</div>
									<input type="file" onChange={handlePicture} id="picture" />
									{picture && (
										<div className="img-holder position-relative">
											<img
												src={`${process.env.REACT_APP_MAIN_URL+picture}`}
												alt="avatar"
												className="imagePreview"
											/>
											<button
												className="position-absolute "
												style={{ top: 5, left: 5, cursor: "pointer" }}
												onClick={() => deletePicture()}
											>
												<i className="fas fa-trash" />
											</button>
										</div>
									)}
								</div>
							</div>
						</div>
						<div className="form-item mt-3">
							<button className="bt bt-success btn-block">ارسال</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default OpinionsCreate;
